<form
  id="form-candidate"
  class="form"
  #ngApplicationForm="ngForm"
  [formGroup]="applicationForm"
  (ngSubmit)="submitSend.emit({ form: applicationForm, jobId: jobId })"
  method="post"
>
  <header class="form__header">
    <h2 class="form__title" i18n>
      Votre candidature
    </h2>
  </header>

  <section class="form__info">
    <header>
      <h2 class="title">
        <svg-icon class="title__icon" icon="exp-account" width="1em"></svg-icon>
        <ng-container i18n>Informations personnelles</ng-container>
      </h2>
    </header>

    <section class="information">
      <mat-form-field appearance="outline" class="information__firstname" [hideRequiredMarker]="true">
        <mat-label i18n>Prénom</mat-label>
        <input matInput type="text" name="firstname" formControlName="firstname" autocomplete="given-name" required />
        <mat-error *ngIf="form.firstname.errors?.required" i18n>
          Le prénom est requis
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="information__lastname" [hideRequiredMarker]="true">
        <mat-label i18n>Nom</mat-label>
        <input matInput type="text" name="lastname" formControlName="lastname" autocomplete="family-name" required />
        <mat-error *ngIf="form.lastname.errors?.required" i18n>
          Le nom est requis
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="information__email" [hideRequiredMarker]="true">
        <mat-label i18n>Email</mat-label>
        <input matInput type="text" name="email" formControlName="email" autocomplete="email" required />
        <mat-error *ngIf="form.email.errors?.required" i18n>
          L'email est requis
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="information__phone" [hideRequiredMarker]="true">
        <mat-label i18n>Téléphone</mat-label>
        <input matInput type="text" name="phone" formControlName="phone" autocomplete="tel" required />
        <mat-error *ngIf="form.phone.errors?.required" i18n>
          Le téléphone est requis
        </mat-error>
      </mat-form-field>
    </section>
  </section>

  <section class="form__cv">
    <header>
      <h2 class="title">
        <svg-icon class="title__icon" icon="exp-notes" width="1em"></svg-icon>
        <ng-container i18n>Votre CV</ng-container>
      </h2>
    </header>

    <app-wiz-file
      class="cv"
      [model]="form.cv.value"
      [editable]="false"
      [uploadPercentage]="!form.cv.value?.id ? (uploadPercent$ | async) : null"
    >
      <ng-container *ngIf="!form.cv.value?.name">
        <app-file-input
          name="cv"
          formControlName="cv"
          appMimeTypes
          appMaxFileSize
          (choseFile)="addFile()"
          [class.file-input-invalid]="ngApplicationForm.submitted && form.cv.errors?.required"
        ></app-file-input>
      </ng-container>
      <mat-error [@slideDown] *ngIf="ngApplicationForm.submitted && form.cv.errors?.required" i18n>
        Le CV est requis
      </mat-error>
    </app-wiz-file>
  </section>

  <section class="form__presentation">
    <mat-form-field class="presentation" appearance="outline" [hideRequiredMarker]="true">
      <mat-label i18n>Présentation (facultatif)</mat-label>
      <textarea
        matInput
        name="presentation"
        formControlName="presentation"
        cdkTextareaAutosize
        cdkAutosizeMinRows="8"
        cdkAutosizeMaxRows="16"
      ></textarea>
    </mat-form-field>
  </section>

  <footer class="form__footer">
    <button
      [disabled]="loading"
      class="btn-save btn btn--shadow form__submit"
      [class.btn--loading]="loading"
      appEventTracker
      eventCategory="Application"
      eventAction="Click Send Application"
    >
      <span [@loaderIndicator] class="btn__loader" *ngIf="loading"></span>
      <ng-container i18n>Envoyer ma candidature</ng-container>
    </button>

    <p *ngIf="error" class="error">
      <ng-container i18n>Une erreur s'est produite</ng-container>
    </p>
  </footer>
</form>
